const isUsableNumber = (n: number | null | undefined): n is number => typeof n === "number" && Number.isFinite(n);

const clampPercent = (value: number): number => Math.max(0, Math.min(100, value));

export function computeDirectRingFill(actual: number | null | undefined, target: number): number {
    if (!isUsableNumber(actual) || !isUsableNumber(target) || target <= 0) return 0;
    return clampPercent((actual / target) * 100);
}

interface InverseRingFillParams {
    actual: number | null | undefined;
    target: number;
}

export function computeInverseRingFill({ actual, target }: InverseRingFillParams): number {
    if (!isUsableNumber(actual) || !isUsableNumber(target) || target <= 0) return 0;
    if (actual <= target) return 100;
    return clampPercent((target / actual) * 100);
}

export function computeMetricStatus(ringFill: number): string {
    if (ringFill >= 100) return "Within target";
    if (ringFill >= 75) return "Close to target";
    if (ringFill >= 40) return "Behind";
    return "Off track";
}
